import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock } from "vue"

import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import SogBadge from "@/shared/ui/SogBadge.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SelectExportBlanksComponent from "@/modules/ShoppingCart/components/SelectExportBlanksComponent.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {computed, ref, watch} from "vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiStore from "@/modules/Store/api";
import InsuranceExportBlank, {
  InsuranceExportBlankStatus,
  sortInsuranceExportBlank
} from "@/shared/model/InsuranceExportBlank";
import {useAccountStore} from "@/stores/accountStore";



export default /*@__PURE__*/_defineComponent({
  __name: 'StoreExportBlankComponent',
  setup(__props, { expose: __expose }) {


const _shoppingCartStore = useShoppingCartStore();
const _accountStore = useAccountStore();
const {currentItem: _current} = storeToRefs(_shoppingCartStore);

const _spinner = useSpinner();

const _loadStoreExportBlank = ref(false);
watch(_loadStoreExportBlank, (value) => {
  if (value) {
    _spinner.show();
  } else {
    _spinner.hide();
  }
});
const _exportBlanksCount = computed(() => {
  return _current.value.shoppingCartItem.insuranceExportBlanks.length;
});
const _exportBlankSearch = ref("");
const _storeExportBlank = ref<InsuranceExportBlank[]>([]);


const _manuellVisible = computed(() => {
    return _current.value.shoppingCartItem.productPrice?.productTypeId === "ExportBlank" ||
        _current.value.shoppingCartItem.productPrice?.productTypeId === "Zoll" && _accountStore.hasExportBlankProduct
  }
)

async function loadStoreExportBlank() {
  _loadStoreExportBlank.value = true;
  try {
    _storeExportBlank.value = [];
    const lst = await apiStore.listInsuranceExportBlank(
      false,
      _exportBlankSearch.value
    );
    if (lst) {
      _storeExportBlank.value = sortInsuranceExportBlank(
        lst.filter(
          (t) =>
            t.status !== InsuranceExportBlankStatus.IncorrectlyFilled &&
            !_current.value.shoppingCartItem.insuranceExportBlanks.some(
              (a) => a.id === t.id
            )
        )
      );
    }
  } finally {
    _loadStoreExportBlank.value = false;
  }
}

async function onAddStoreExportBlanks() {
  await _shoppingCartStore.addStoreExportBlanks();
}

async function onExportBlank() {
  await _shoppingCartStore.navigate("exportblank");
}

__expose({loadStoreExportBlank})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        SubTitle: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Wählen Sie vorhandene Ausfuhrformulare aus ", -1)
        ]))]),
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" Ausfuhrformulare ", -1))
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
            return _createVNode(SogSkeleton, {
              key: index,
              height: "48px"
            })
          }), 64))
        ]),
        _: 1
      }, 512), [
        [_vShow, _loadStoreExportBlank.value]
      ]),
      _withDirectives(_createVNode(SogCardActions, { "is-toolbar": true }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogBadge, {
            value: _exportBlanksCount.value,
            "badge-style": "primary",
            "badge-type": "notification",
            overlap: "true"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cart-arrow-down",
                tooltip: "In den Einkaufswagen legen",
                onClick: onAddStoreExportBlanks
              }, null, 512), [
                [_vShow, _unref(_current).shoppingCartItem.insuranceExportBlanks.length > 0]
              ])
            ]),
            _: 1
          }, 8, ["value"]), [
            [_vShow, _exportBlanksCount.value > 0]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-form-textbox",
            tooltip: "Manuel angeben",
            onClick: onExportBlank
          }, null, 512), [
            [_vShow, _manuellVisible.value]
          ]),
          _createVNode(SogTextBox, {
            modelValue: _exportBlankSearch.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_exportBlankSearch).value = $event)),
            placeholder: "Nummer",
            width: "150px",
            "interval-modified": loadStoreExportBlank,
            style: {"padding-left":"5px"}
          }, null, 8, ["modelValue"]),
          _createVNode(SogCardActionButton, {
            kind: _unref(SogButtonKind).Search,
            onClick: loadStoreExportBlank
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_loadStoreExportBlank.value]
      ]),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SelectExportBlanksComponent, { "export-blanks": _storeExportBlank.value }, null, 8, ["export-blanks"])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_loadStoreExportBlank.value]
      ])
    ]),
    _: 1
  }))
}
}

})